import React from 'react';
import classNames from 'classnames';
import Loader from '../loader';
import styles from './animated-loader.scss';

type Props = {
  shouldShowLoader?: boolean;
  isLoading: boolean;
  children?: React.ReactNode;
  className?: string;
};

const AnimatedLoader: React.FC<Props> = ({
  shouldShowLoader = true,
  isLoading,
  className,
  children,
}) => (
  <div className={classNames(styles.container, className)}>
    {shouldShowLoader && isLoading ? (
      <div key="loader" className={styles.loaderBox}>
        <Loader />
      </div>
    ) : null}
    {isLoading ? null : <div key="content">{children}</div>}
  </div>
);

export default AnimatedLoader;
